import {
    setShowTiles,
    setIsActiveChat,
    clearSelectedTileId,
    clearPromptItems,
    clearSelectedPromptItem
} from '../reducers/uiReducer'
import { setLoading } from '../reducers/loadingReducer';
import {
    clearSelectedDocument
} from '../reducers/documentsReducer';
import {
    clearSelectedDataset
} from '../reducers/datasetsReducer';
import {
    addMessage
} from '../reducers/messagesReducer';
import {
    showToast
} from '../reducers/uiReducer';
import { sendMessage } from '../services/apiService';

const handleEnterPress = async (text, context = null, dispatch, chatContext, promptItems) => {
    dispatch(setLoading(true));
    dispatch(setShowTiles(false));
    dispatch(setIsActiveChat(true));

    dispatch(clearSelectedTileId());
    dispatch(clearSelectedDocument());
    dispatch(clearSelectedDataset());
    dispatch(clearSelectedPromptItem());
    dispatch(clearPromptItems());

    const newUserMessage = {
        role: 'user',

        componentType: promptItems.length > 0 ? 'text-with-context' : 'text',
        //componentType: 'text-with-context',
        content: [{ type: 'text', text }],
        context: context ? context : null,
        promptItems: promptItems,
        icon: 'user',
    };

    const updatedChatContext = Array.isArray(chatContext)
        ? [...chatContext, newUserMessage]
        : [newUserMessage];

    console.log("chat context", updatedChatContext)

    dispatch(addMessage(newUserMessage));

    try {
        const isChartPrompt = false;

        const response = await sendMessage(
            updatedChatContext,
            isChartPrompt ? 'structured_chart_data' : 'general',
        );

        if (isChartPrompt && response?.data) {
            const chartMessage = {
                role: 'assistant',
                componentType: 'chart',
                content: [{ type: 'structured_chart_data', data: response }],
            };

            dispatch(addMessage(chartMessage));
        } else if (response && response.choices?.[0]?.message) {
            const assistantMessage = {
                role: 'assistant',
                componentType: response.choices[0].message.componentType,
                content: [
                    { type: 'text', text: response.choices[0].message.content },
                ],
            };

            dispatch(addMessage(assistantMessage));
        } else {
            if (response.error) {
                throw new Error(response.error);
            } else {
                throw new Error('Unknown response format');
            }
        }
    } catch (error) {
        console.error('Failed to send message:', error);
        dispatch(
            addMessage({
                role: 'error',
                content: [{ type: 'text', text: `${error}` }],
            }),
        );
        dispatch(
            showToast({ message: 'Failed to send message', severity: 'error' }),
        );
    } finally {
        dispatch(setLoading(false));
    }
};

export default handleEnterPress;